import React from 'react';

import Space from 'components/generic/Space.component';
import STAFF_NAME from 'constants/staff/name.const';
import { useTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';

// FIXME: component should not depend upon where it is put
const IS_OUTSIDE_CASHUP = fromAnyToBool(document.location.href.indexOf('cashup') <= 0);

const byValidStylist = ({ has_column: hasColumn, serves_as_waitlist: waitlist, status }) => status !== 'deleted' && hasColumn && waitlist !== true;

export const StylistTypeDropdown = ({ stylists, onSelectStylist, openDropdownStylist, isStylistOpen }) => {
  const { t } = useTranslation();

  const normalizedStylists = IS_OUTSIDE_CASHUP ? asArray(stylists) : asArray(stylists).filter(byValidStylist);

  const hasStylists = isFullArray(normalizedStylists);

  if (hasStylists && normalizedStylists.indexOf(STAFF_NAME.all) < 0) {
    normalizedStylists.unshift(STAFF_NAME.self);
    normalizedStylists.unshift(STAFF_NAME.employed);
    normalizedStylists.unshift(STAFF_NAME.all);
  }

  return (
    <div data-bem="StylistTypeDropdown" role="button" tabIndex="0">
      {isStylistOpen && (
        <div className="select-box--items">
          <span className="label">{t('businessReports.monthly.filterHeading')}</span>
          {hasStylists && (
            <>
              {normalizedStylists.map((stylist, index) => {
                const { name } = asObject(stylist);

                const handleClick = () => {
                  onSelectStylist(stylist);
                  openDropdownStylist();
                };

                return (
                  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                  <div key={createNodeKey({ index, tag: name })} className="select-by" onClick={handleClick}>
                    {IS_OUTSIDE_CASHUP && name && `${name} ${stylist.is_self_employed ? t('businessReports.monthly.staffSelfEmployed') : t('businessReports.monthly.staffEmployed')}`}
                    {IS_OUTSIDE_CASHUP && !name && `${stylist}`}

                    {!IS_OUTSIDE_CASHUP && (
                      <>
                        <Space>{stylist.user_name ? stylist.user_name : stylist}</Space>
                        <Space>{stylist.is_self_employed ? t('businessReports.monthly.staffSelfEmployed') : t('businessReports.monthly.staffEmployed')}</Space>
                      </>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default StylistTypeDropdown;
